import styled from 'styled-components'
import {AbsoluteCenter} from '../../styles'

export const Modal = styled.div.attrs(({textColor}) => ({
  style: {
    backgroundColor: textColor
  }
}))`
  ${AbsoluteCenter}

  animation: glow 1s forwards;

  box-sizing: border-box;

  padding: 3.75rem;
  max-width: 50rem;
  width: calc(100vw - 3.75rem);

  z-index: 3;

  @media (max-width: 43rem) {
    padding: 1.6rem;

    width: calc(100vw - 1.6rem);
  }
`

export const BG = styled.div`
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 2;
`

export const Close = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  height: 1.6rem;
  width: 1.6rem;
  padding: 0;
  position: absolute;
  right: 3.75rem;
  top: 3.75rem;

  &::before,
  &::after {
    background: ${(props) => props.bgColor};
    content: '';
    position: absolute;
    height: 2rem;
    width: 0.125rem;
    left: 1rem;
    top: 0;
  }

  &::before {
    transform: rotate(45deg);
  }
  &::after {
    transform: rotate(-45deg);
  }

  @media (max-width: 43rem) {
    top: 1.6rem;
    right: 1.6rem;
  }
`
